import React from 'react';
import { Row, Col, Tag } from 'antd';
import OwlIcon from '../../../assets/owl-icon.svg';
import IncreaseLearningIcon from '../../../assets/increase-learning.svg';
import { FormattedMessage } from 'react-intl';

export const Benefits = () => {
  return (
    <>
      <Row justify='center' style={{ margin: '40px auto' }}>
        <Col
          xl={20}
          sm={22}
          style={{
            background: '#5BBCBD',
            padding: 40,
            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'
          }}
        >
          {/* BENEFITS TAG */}
          <div style={{ marginBottom: 40 }}>
            <Tag
              style={{
                background: '#E5A84F',
                color: '#fff',
                border: 'none',
                fontWeight: 'bolder'
              }}
            >
              <FormattedMessage id='landing.benefits.label'/>
            </Tag>
          </div>
          {/* ROW FOR TWO COLUMNS */}
          <Row justify='space-around'>
            {/* LEFT COLUMN */}
            <Col xl={10}>
              <img src={OwlIcon} alt='' />
              <br />
              <br />
              <p style={{ color: '#fff', fontFamily: 'Montserrat Bold', fontSize: '2em' }}>
                <FormattedMessage id='landing.benefits.subTitleOne'/>
              </p>
              <p style={{ color: '#fff' }}>
                <FormattedMessage id='landing.benefits.descriptionOne'/>
              </p>
            </Col>
            {/* RIGHT COLUMN */}
            <Col xl={10}>
              <img src={IncreaseLearningIcon} alt='' />
              <br />
              <br />
              <p style={{ color: '#fff', fontFamily: 'Montserrat Bold', fontSize: '2em' }}>
                <FormattedMessage id='landing.benefits.subTitleTwo'/>
              </p>
              <p style={{ color: '#fff' }}>
                <FormattedMessage id='landing.benefits.descriptionTwo'/>
              </p>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};
